<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <v-card height="400px">
            <v-container grid-list-xl fluid>
              <v-layout justify-center>
                <v-flex lg12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-spacer></v-spacer>
                      <v-toolbar-title class="indigo--text"
                        >Descarga Registro Civil
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-card-actions class="pb-4">
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        @click="downloadFile()"
                      >
                        Descargar
                        <v-icon right dark>cloud_download</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-flex lg12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-spacer></v-spacer>
                      <v-toolbar-title class="indigo--text"
                        >Carga Registro Civil
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-actions class="pb-3">
                      <v-spacer></v-spacer>
                      <data-adjunto
                        :documentoId="id"
                        :tipeView="tipeView"
                        :tipeArchive="tipeArchive"
                      >
                      </data-adjunto>
                      <v-btn
                        depressed
                        outline
                        icon
                        fab
                        dark
                        color="primary"
                        medium
                        title="Cargar"
                        @click="envio()"
                      >
                        cargar
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";

export default {
  name: "registro-civil",
  components: {
    DataAdjunto,
  },
  data() {
    return {
      tipeArchive: "",
      id: "",
      tipeView: "",
    };
  },

  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.tipeArchive = "*";
  },
  mounted() {},
  computed: {},
  methods: {
    downloadFile() {
      axios
        .get("/rc/txtCheckRC", { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_REGISTRO_CIVIL.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    envio() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        excelFile: base64EncodedStr,
        idContrato: idContrato,
      };
      axios
        .post("/rc/uploadData", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.reload();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.reload();
          }
        });
    },
  },
};
</script>
